import { render, staticRenderFns } from "./editNoticeViewList.vue?vue&type=template&id=65434f55&scoped=true"
import script from "./editNoticeViewList.vue?vue&type=script&lang=js"
export * from "./editNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./editNoticeViewList.vue?vue&type=style&index=0&id=65434f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65434f55",
  null
  
)

export default component.exports